import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { SafeSend, SafeSendType } from '@ucx-js/chat-ui';
import { SafeSendActions } from './safe-send.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { SafeSendEffects } from './safe-send.effects';

export const initialState: Readonly<SafeSend> = {
  submitRequested: false,
  submitted: false,
  disabled: false,
  fields: [],
  formValues: null,
  type: SafeSendType.PROACTIVE,
  safesendInfoArray: [],
};

export const safeSendFeature = createFeature({
  name: 'safeSend',
  reducer: createReducer(
    initialState,
    on(SafeSendActions.createSafeSend, (state, { value }) => {
      return value;
    }),
    on(SafeSendActions.updateSafeSend, (state, { value }) => {
      return value;
    }),
    on(SafeSendActions.submitSuccessfully, (state) => {
      return { ...state, submitted: true };
    }),
    on(SafeSendActions.submitFailed, (state) => {
      return { ...state, submitted: false };
    })
  ),
});

export const {
  selectSafeSendState,
  selectSubmitted,
  selectDisabled,
  selectFields,
  selectFormValues,
  selectType,
} = safeSendFeature;

export function provideSafeSendFeature() {
  return makeEnvironmentProviders([
    provideState(safeSendFeature),
    provideEffects(SafeSendEffects),
  ]);
}
